module.exports = __webpack_public_path__ + "img/undraw_in_thought_gjsf.6aeae031.svg";